import { Reveal } from "./Reveal";
import BreathPacer from "./BreathPacer";
import CaffeineTimeline from "./CaffeineTimeline";

const SALINE_STEPS = [
  "Al risveglio: 500 ml di acqua a temperatura ambiente",
  "Aggiungi una punta di sale marino integrale e magnesio",
  "Assumi entro 5 minuti, prima di ogni input digitale",
];

const cardCls =
  "bg-card border border-white/10 clip-card p-6 sm:p-8 hover:border-[rgba(255,85,0,0.4)] transition-colors flex flex-col";

export default function Protocols() {
  return (
    <section id="protocolli" className="relative py-24 sm:py-32 bg-panel">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.35em] text-neon">
            Protocolli di Reset Somatico
          </p>
          <h2 className="mt-4 font-display font-bold tracking-tight text-white text-2xl sm:text-3xl lg:text-4xl max-w-3xl">
            Tre interruttori ingegneristici per tornare a −70mV
          </h2>
        </Reveal>
        <div className="mt-16 grid md:grid-cols-3 gap-8">
          <Reveal delay={0.1} className="h-full">
            <article data-testid="protocol-ancora-salina" className={`${cardCls} h-full`}>
              <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-neon">
                Protocollo 01
              </span>
              <h3 className="mt-3 font-display font-semibold text-white text-xl">
                ANCORA SALINA
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-[#C4C4D0]">
                Ripristino del potenziale di membrana neuronale a −70mV tramite
                carico elettrolitico mirato e conducibilità cellulare.
              </p>
              <ol className="mt-6 space-y-3">
                {SALINE_STEPS.map((s, i) => (
                  <li key={i} className="flex gap-3 text-sm text-[#C4C4D0]">
                    <span className="font-mono text-neon shrink-0">
                      0{i + 1}
                    </span>
                    {s}
                  </li>
                ))}
              </ol>
            </article>
          </Reveal>
          <Reveal delay={0.2} className="h-full">
            <article className={`${cardCls} h-full`}>
              <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-neon">
                Protocollo 02
              </span>
              <h3 className="mt-3 font-display font-semibold text-white text-xl">
                RESPIRAZIONE QUADRATA
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-[#C4C4D0]">
                Rilascio di GABA e decompressione vagale in 4 fasi da 4
                secondi. Segui il pacer visivo.
              </p>
              <div className="mt-auto">
                <BreathPacer />
              </div>
            </article>
          </Reveal>
          <Reveal delay={0.3} className="h-full">
            <article className={`${cardCls} h-full`}>
              <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-neon">
                Protocollo 03
              </span>
              <h3 className="mt-3 font-display font-semibold text-white text-xl">
                BUFFER DELLA CAFFEINA
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-[#C4C4D0]">
                Ritarda la prima caffeina di 90–120 minuti dal risveglio per
                impedire il crash pomeridiano di adenosina.
              </p>
              <div className="mt-auto">
                <CaffeineTimeline />
              </div>
            </article>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
